<script>

	import { quintOut } from 'svelte/easing';
	import { fade, draw, fly } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';
	import { onMount } from 'svelte';
	import { initializeApp } from "firebase/app";
	import { getAnalytics, logEvent } from "firebase/analytics";

	// analytics
	const firebaseApp = initializeApp({
		apiKey: "AIzaSyB_vZXeB-LFxBZrvRw-4FUY2Wa3AgB2tV0",
		authDomain: "bpan-digital.firebaseapp.com",
		projectId: "bpan-digital",
		storageBucket: "bpan-digital.appspot.com",
		messagingSenderId: "479588866848",
		appId: "1:479588866848:web:d69809016f876519a1d545",
		measurementId: "G-X2G65N4XCK"
	});
	const analytics = getAnalytics(firebaseApp);

	// custom animation
	const expand = (node, params) => {
		const {
			delay = 0,
			duration = 400,
			easing = cubicOut
		} = params;
		return {
			delay,
			duration,
			easing,
			css: t => `opacity: ${t}; stroke-width: ${t * parseFloat(getComputedStyle(node).strokeWidth)}`
		};
	};

	// paths
	const letter_b = "M175.475 585V407.266H222.228C241.352 407.266 255.797 411.172 265.562 418.984C275.41 426.715 280.333 437.987 280.333 452.798C280.333 463.54 277.607 472.451 272.154 479.531C266.702 486.611 259.011 491.128 249.083 493.081C260.313 494.546 269.672 499.429 277.159 507.729C284.646 515.949 288.39 525.389 288.39 536.05C288.39 551.187 283.466 563.149 273.619 571.938C263.854 580.646 250.222 585 232.726 585H175.475ZM182.066 497.231V578.408H233.458C248.513 578.408 260.313 574.705 268.858 567.3C277.485 559.813 281.798 549.478 281.798 536.294C281.798 525.063 277.647 515.827 269.347 508.584C261.046 501.26 249.938 497.476 236.021 497.231H182.066ZM182.066 490.64H224.669C240.864 490.64 253.071 487.547 261.29 481.362C269.509 475.096 273.619 465.412 273.619 452.31C273.619 427.082 256.977 414.264 223.692 413.857H182.066V490.64Z";
	const letter_p = "M455.433 228.927V304H448.841V126.266H504.383C522.531 126.266 536.609 130.864 546.619 140.06C556.71 149.174 561.756 161.869 561.756 178.146C561.756 194.259 556.832 206.71 546.985 215.499C537.22 224.288 523.304 228.764 505.237 228.927H455.433ZM455.433 222.335H504.383C520.415 222.335 532.866 218.469 541.736 210.738C550.688 203.007 555.164 192.224 555.164 178.39C555.164 164.067 550.688 152.918 541.736 144.942C532.866 136.886 520.415 132.857 504.383 132.857H455.433V222.335Z";
	const letter_a = "M824.835 531.899H737.799L718.023 585H710.821L777.35 407.266H785.406L851.935 585H844.732L824.835 531.899ZM740.24 525.308H822.394L781.378 415.2L740.24 525.308Z";
	const letter_n = "M563.465 856H556.873L442.127 689.496V856H435.413V678.266H442.127L556.873 844.403V678.266H563.465V856Z";
	const circle = "M635.755 558.645C636.087 557.881 636.412 557.114 636.732 556.344C643.993 538.835 648 519.635 648 499.5C648 479.365 643.993 460.165 636.732 442.656C636.412 441.886 636.087 441.119 635.755 440.355C635.422 439.59 635.083 438.829 634.739 438.07C632.241 439.155 631.066 442.047 632.113 444.571C639.127 461.484 643 480.033 643 499.5C643 518.967 639.127 537.516 632.113 554.429C631.066 556.953 632.241 559.845 634.739 560.93C635.083 560.171 635.422 559.41 635.755 558.645ZM560.93 634.739C559.845 632.241 556.953 631.066 554.429 632.113C537.516 639.127 518.967 643 499.5 643C480.033 643 461.484 639.127 444.571 632.113C442.047 631.066 439.155 632.241 438.07 634.739C438.829 635.083 439.59 635.422 440.355 635.755C441.119 636.087 441.886 636.412 442.656 636.732C460.165 643.993 479.365 648 499.5 648C519.635 648 538.835 643.993 556.344 636.732C557.114 636.412 557.881 636.087 558.645 635.755C559.41 635.422 560.171 635.083 560.93 634.739ZM364.261 560.93C366.759 559.845 367.934 556.953 366.887 554.429C359.873 537.516 356 518.967 356 499.5C356 480.033 359.873 461.484 366.887 444.571C367.934 442.047 366.759 439.155 364.261 438.07C363.917 438.829 363.578 439.59 363.245 440.355C362.913 441.119 362.588 441.886 362.268 442.656C355.007 460.165 351 479.365 351 499.5C351 519.635 355.007 538.835 362.268 556.344C362.588 557.114 362.913 557.881 363.245 558.645C363.578 559.41 363.917 560.171 364.261 560.93ZM438.07 364.261C439.155 366.759 442.047 367.934 444.571 366.887C461.484 359.873 480.033 356 499.5 356C518.967 356 537.516 359.873 554.429 366.887C556.953 367.934 559.845 366.759 560.93 364.261C560.171 363.917 559.41 363.578 558.645 363.245C557.881 362.913 557.114 362.588 556.344 362.268C538.835 355.007 519.635 351 499.5 351C479.365 351 460.165 355.007 442.656 362.268C441.886 362.588 441.119 362.913 440.355 363.245C439.59 363.578 438.829 363.917 438.07 364.261Z"

	// csv animations
	const logo_fade_params = {duration: 200};
	const logo_draw_params = {duration: 1000};
	const logo_expand_params = {duration: 400, delay: 800, easing: quintOut};

	// title animations
	const title_fade_params = (i) => { return {delay: 50 + i * 100, duration: 200}};
	const title_char_style = (char) => char == "N" ? "color: #ff0000" : "";

	// email animation
	const email_fade_params = {duration: 500, delay: 1000, easing: quintOut};

	// generic animation
	const fly_params = {y: -20, duration: 800};

	let visible = false;

	onMount(async () => {
		visible = true;
	});

	const logoClick = () => {
		logEvent(analytics, 'click_logo');
		visible = false;
		setTimeout(() => { visible = true }, 850);
	};

	const emailAction = () => {
		logEvent(analytics, 'click_email');
		return true;
	};

</script>

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap" rel="stylesheet">

{#if visible}

	<div class="container">

		<div class="logo" on:click={logoClick}>
			<svg viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g out:fade={logo_fade_params}>
					<path in:draw={logo_draw_params} fill-rule="evenodd" clip-rule="evenodd" d={circle} style="stroke: black; stroke-width: 2;" />
					<path in:expand={logo_expand_params} fill-rule="evenodd" clip-rule="evenodd" d={circle} style="fill: black;" />
					
					<path in:draw={logo_draw_params} d={letter_b} style="stroke: black; stroke-width: 5;" />
					<path in:expand={logo_expand_params} d={letter_b} style="fill: black;" />

					<path in:draw={logo_draw_params} d={letter_p} style="stroke: black; stroke-width: 5;" />
					<path in:expand={logo_expand_params} d={letter_p} style="fill: black;" />

					<path in:draw={logo_draw_params} d={letter_a} style="stroke: black; stroke-width: 5;" />
					<path in:expand={logo_expand_params} d={letter_a} style="fill: black; " />

					<path in:draw={logo_draw_params} d={letter_n} style="stroke: #ff0000; stroke-width: 5;" />
					<path in:expand={logo_expand_params} d={letter_n} style="fill: #ff0000;" />

					<rect in:expand={logo_expand_params} x="148.536" y="145" width="1000" height="5" rx="2.5" transform="rotate(45 148.536 145)" fill="black"/>
					<rect in:expand={logo_expand_params} x="145" y="852.107" width="1000" height="5" rx="2.5" transform="rotate(-45 145 852.107)" fill="black"/>
				</g>
			</svg>
		</div>

		<div class="logo-title" out:fly={fly_params}>
			{#each 'BPAN DIGITAL' as char, i}
				<span in:fade={title_fade_params(i)} style={title_char_style(char)} >{char}</span>
			{/each}
		</div>

		<div class="email">
			<a in:fade={email_fade_params} out:fly={fly_params} href="mailto:hello@bpan.digital" on:click={emailAction}>hello@bpan.digital</a>
		</div>

	</div>

{/if}

<style>
	.logo svg {
		width: 150;
		height: 150;
	}

	.logo path {
		fill: white;
		opacity: 1;
	}

	.logo-title {
		font-size: 2vw;
		font-family: 'Roboto', sans-serif;
		letter-spacing: 0.12em;
		color: #676778;
		font-weight: 400;
		justify-self: center;
	}

	.logo-title span {
		will-change: filter;
	}

	.email {
		font-family: 'Roboto', sans-serif;
		color: #676778;
		justify-self: center;
	}

	.container {
		display: grid;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
	}
</style>